import { Component, Input } from '@angular/core';

@Component({
  selector: 'btn-with-loader',
  templateUrl: 'btn-with-loader.component.html',
  styles: [':host { display: inline-block; }']
})
export class ButtonWithLoaderComponent {

  @Input() label = '';
  @Input() isLoading: null | boolean = false;

  constructor() {
  }

}
